import styled from 'styled-components';
import {Collapse, Space} from 'antd';
import {typographyStyles} from '../../../../utils/styles';

const StyledVendorDetails = styled.div`
  & > div {
    padding: 24px 24px 24px 0;
  }

  .vendor-delete-modal {
    .ant-modal-body {
      p {
        max-width: 250px;
      }
    }
  }
`;

const StyledVendorDetailsCollapse = styled(Collapse)`
  .ant-collapse-header {
    ${typographyStyles.heading.h5};

    align-items: center !important;
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 0 !important;
    color: ${props => props.theme.colors.neutral_10};
  }

  .ant-collapse-extra {

    .ant-btn.ant-btn-icon-only {
      align-items: center;
      display: flex;
      justify-content: center;

      .anticon {
        font-size: 20px;
      }
    }
  }
`;

const StyledVendorDetailsContentSpace = styled(Space)`
  width: 100%;
`;


export {
  StyledVendorDetails,
  StyledVendorDetailsCollapse,
  StyledVendorDetailsContentSpace
};
